'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'rv';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = ['M16 48l0 251.9 108.2 79.3C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48l89.6 0 0-232 0-8 8 0 216 0 0-96L384 48l-16 0L240 48l-16 0L16 48zm64 64l16 0 192 0 16 0 0 16 0 96 0 16-16 0L96 240l-16 0 0-16 0-96 0-16zM240 16l0 16 128 0 0-16L240 16zM384 272l0 120 0 8 19.3 0c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64l11.3 0 0-16 8 0 32 0 0-96-200 0-8 0 0-16-32 0z', 'M240 16l0 16 128 0 0-16L240 16zM224 32l0-16 0-16 16 0L368 0l16 0 0 16 0 16 216 0 8 0 0 8 0 112 0 8-8 0-216 0 0 232 0 8-8 0-91.3 0c2.2 7.6 3.3 15.7 3.3 24c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-10.5 1.8-20.6 5.2-30L3.3 310.5 0 308.1 0 304 0 40l0-8 8 0 216 0zM384 48l-16 0L240 48l-16 0L16 48l0 251.9 108.2 79.3C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48l89.6 0 0-232 0-8 8 0 216 0 0-96L384 48zM200 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0-160a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM288 128L96 128l0 96 192 0 0-96zM96 112l192 0 16 0 0 16 0 96 0 16-16 0L96 240l-16 0 0-16 0-96 0-16 16 0zm320 80l8 0 104 0 2.7 0 2.2 1.7 104 80 3.1 2.4 0 3.9 0 112 0 8-8 0-40 0-8 0 0-16 8 0 32 0 0-96-200 0-8 0 0-16 8 0 184.5 0-83.2-64L424 208l-8 0 0-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;